import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { DetailedHTMLProps, LabelHTMLAttributes } from 'react'

import { theme as newTheme } from 'styles/theme/hav-theme'
type LabelProps = DetailedHTMLProps<
  LabelHTMLAttributes<HTMLLabelElement>,
  HTMLLabelElement
>

interface LabelStyledProps extends LabelProps {
  disabled?: boolean
}

export const LabelStyled = styled.label<LabelStyledProps>`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  font-family: ${newTheme.typography.family.primary};
  font-size: ${newTheme.typography.sizes.xs};
  color: ${newTheme.colors.neutral.black};
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: default;
      color: ${newTheme.colors.neutral.mediumhover};
    `}
`

export const InputStyled = styled.input`
  width: ${newTheme.typography.sizes.xs};
  height: ${newTheme.typography.sizes.xs};
  margin: 0;
  margin-right: ${newTheme.spacing.xs};
  accent-color: ${newTheme.colors.primary.main};
  cursor: pointer;

  :disabled {
    cursor: default;
  }
`
